var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "el-form",
          {
            ref: "changeStatusForm",
            staticClass: "form-container",
            attrs: {
              model: _vm.changeStatusForm,
              autocomplete: "on",
              "label-position": "left",
              size: "mini",
            },
          },
          [
            _c("el-row", [
              _c("div", { staticStyle: { "padding-bottom": "10px" } }, [
                _c("b", [_vm._v(_vm._s(_vm.changeStatusForm.orderId))]),
                _vm._v(" Current Order Status is "),
                _c("b", [_vm._v(_vm._s(_vm.changeStatusForm.currentStatus))]),
              ]),
            ]),
            _c(
              "el-row",
              [
                _c(
                  "el-form-item",
                  { staticClass: "w-50", attrs: { label: "New Order Status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          "value-key": "key",
                          placeholder: "Select Order Status",
                        },
                        model: {
                          value: _vm.changeStatusForm.newStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.changeStatusForm, "newStatus", $$v)
                          },
                          expression: "changeStatusForm.newStatus",
                        },
                      },
                      _vm._l(_vm.options, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.key,
                            attrs: { label: item.value, value: item.key },
                          },
                          [_vm._v(" " + _vm._s(item.value) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "text-align": "center", "margin-top": "10px" },
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("Cancel")]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitChangeStatus } },
          [_vm._v("Submit Status Change")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }